module.exports = __webpack_public_path__ + "media/images/camera-circle-67d077fe.svg";